import { useMocks } from '../../shared/env';
import { HttpTaxJurisdictionGateway } from './HttpTaxJurisdictionGateway';
import { MockTaxJurisdictionGateway } from './MockTaxJurisdictionGateway';
import type { TaxJurisdictionGateway } from './TaxJurisdictionGateway';

export const taxJurisdictionGateway: TaxJurisdictionGateway = useMocks ? new MockTaxJurisdictionGateway() : new HttpTaxJurisdictionGateway();
export type { TaxJurisdictionGateway } from './TaxJurisdictionGateway';
